import React from 'react'
import {
  FieldErrorAndDescription,
  FieldErrorAndDescriptionProps,
} from 'shared/components/form/field-error-and-description'
import { FieldLabel, FieldLabelProps } from 'shared/components/form/field-label'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

type DeadlineSettingsExpirationInputProps = FieldErrorAndDescriptionProps &
  FieldLabelProps & {
    value: number
    onChange: (value: number) => void
    isFetching: boolean
    wrapperClassName?: string
  }

function DeadlineSettingsExpirationInput({
  onChange,
  value,
  isFetching,
  label,
  labelClassName,
  required = false,
  wrapperClassName,
  error,
}: DeadlineSettingsExpirationInputProps) {
  const { t } = useLocoTranslation()

  return (
    <div className={`flex flex-col gap-1 text-sm font-medium ${wrapperClassName || ''}`}>
      <FieldLabel label={label} labelClassName={labelClassName} required={required} />
      <div
        className={`focus-within:border-brand-primary main-transition-colors flex w-fit rounded-lg ${
          error ? 'border-danger' : 'border-text-secondary/30'
        } border-text-secondary/30 border ${isFetching && 'bg-skeleton-primary/40 animate-pulse'}`}
      >
        <input
          value={value}
          disabled={isFetching}
          type={'number'}
          onChange={e => {
            const newValue = e.target.valueAsNumber
            if (newValue > 100) {
              // check with backend
              onChange(100)
            } else if (newValue < 0) {
              onChange(0)
            }
            onChange(newValue)
          }}
          className={`main-transition-colors text-text-primary focus:border-brand-primary placeholder:text-text-tertiary/70 peer w-[66px] rounded-lg px-4 py-2.5 focus:outline-hidden`}
        />
        <div
          className={
            'bg-background-primary flex w-fit w-fit items-center justify-center rounded-r-lg px-4 py-2.5'
          }
        >
          {value > 1
            ? t('dashboard.transactions.sub_interval.days')
            : t('dashboard.transactions.sub_interval.day')}
        </div>
      </div>
      <FieldErrorAndDescription error={error} />
    </div>
  )
}

export default DeadlineSettingsExpirationInput
